module.exports = __webpack_public_path__ + "fonts/Vonnes-Book.69feb295.otf";